import axios from 'axios'
import { useParams, Link } from 'react-router-dom'
import useSwr from 'swr'
import CardArticle from 'src/components/molecules/CardArticle'

const fetcher = async url => {
  const response = await axios(url)
  return response.data
}

const ArticleTag = () => {

  const { tag } = useParams()
  const API = process.env.REACT_APP_API
  // endpoint backend
  const { data, isLoading } = useSwr(
    `${API}/articles/tag/${tag}`,
    fetcher
  )
  const articles = data?.articles || []
  return (

    <div className="min-h-screen bg-[#F7F8FA]">
      {/* Header */}
      <div className="border-b border-gray-200 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-14 py-10">
          <p className="text-[#2E7462] font-semibold text-lg">
            Tag
          </p>

          <h1
            className="text-4xl md:text-6xl font-bold text-[#0B132A] mt-2 break-words"
          >
            #{decodeURIComponent(tag)}
          </h1>

          <p className="text-slate-500 mt-4 text-base md:text-lg">
            Showing articles tagged with{' '}
            <span className="font-semibold text-[#2E7462]">
              #{decodeURIComponent(tag)}
            </span>
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-14 py-10">
        {isLoading ? (
          <div className="text-center py-20">
            <p className="text-slate-500">
              Loading articles...
            </p>
          </div>

        ) : articles.length > 0 ? (

          <div
            className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8"
          >

            {articles.map(item => (

              <CardArticle
                key={item.id}
                slug={`/articles/${item.slug}`}
                publishedAt={item.published_at}
                image={`${process.env.REACT_APP_IMAGE}/article/${item.image}`}
                title={item.title}
                summary={item.summary}
                type="vertical"
              />

            ))}
          </div>

        ) : (

          <div className=" bg-white rounded-2xl border border-gray-100 p-10 text-center">
            <h2 className="text-2xl font-semibold text-[#0B132A] mb-3">
              Artikel tidak ditemukan
            </h2>

            <p className="text-slate-500 mb-6">
              Belum ada artikel dengan tag #
              {decodeURIComponent(tag)}
            </p>

            <Link
              to="/articles"
              className="inline-flex items-center justify-center px-6 py-3 rounded-xl bg-[#2E7462] hover:bg-[#245c4e] text-white font-medium transition"
            >
              Kembali ke Articles
            </Link>
          </div>
        )}
      </div>
    </div>
  )
}

export default ArticleTag